import { LogoSpine } from 'core/display/spines/LogoSpine'

export default class makeLogoSpine extends PIXI.Container{
  constructor(data) {
    super()
    this.addChild(new LogoSpine(data, this))
  }
}
